import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import Scrollbar from 'react-scrollbars-custom';
import CustomButton from '../../../../features/customButton/ui/main/CustomButton';
import Toggle from '../../../../baseComponents/gui/toggle/Toggle';
import CustomModal from '../../../../baseComponents/gui/customModal/CustomModal';
import { useRequestsHandlerData } from '../../../../../hooks/useRequestsHandlerData';
import AppLoader from '../../../../features/appLoader/AppLoader';
import { useBuyOrPutItem } from '../../../../../hooks/useBuyOrPutItem';
import { useTranslation } from '../../../../../translations';
import { useApplicationCallbacks } from '../../../../../providers/application-callbacks';
import useGetItems from '../../model/hooks/useGetItems';
import Filters from '../Filters/Filters';
import { customizationScrollbarSettings } from '../../../../../constants/copyright';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import content from '../../constants/content';
import { CLOTH, WISH } from '../../constants/types';
import { useRequests } from '../../../../../redux/reducer/requests';
import { useFeatureToggle } from '../../../../../hooks/useFeatureToggle';

const { title, toggle, buttons } = content;

export default function MyGiftModal() {
  const { wishes, clothes } = useGetItems();
  const [customState, setCustomState] = useState(toggle?.[0]?.action);
  const {
    authData: { isWeb },
  } = useRequests();

  const gameTamagotchiPromo8March = useFeatureToggle('gameTamagotchiPromo8March');

  const callbacks = useApplicationCallbacks();
  const { t } = useTranslation();
  const toggleFuncs = toggle.reduce((acc, { action }) => {
    acc[action] = () => setCustomState(action);
    return acc;
  }, {});

  useEffect(() => {
    if (gameTamagotchiPromo8March) {
      callbacks.getWishes();
    }
  }, []);

  const isPendingWish = useRequestsHandlerData([{ address: 'requestsWishGet' }]);
  const isPendingEquip = useBuyOrPutItem();

  return (
    <CustomModal className={'custom-modal_fullpage'} animation={['fade', 'scale', 'scale-bounce']}>
      <section
        className={classNames('my-gift', {
          ['my-gift_webView']: !isWeb,
        })}
      >
        <div className={'my-gift__content'}>
          <h2 className={'my-gift__title'}>{t(title)}</h2>
          <div className={'my-gift__block'}>
            <Scrollbar {...customizationScrollbarSettings}>
              {gameTamagotchiPromo8March && <Toggle list={toggle} funcs={toggleFuncs} className={'toggle_shop'} />}

              <SwitchTransition>
                <CSSTransition key={customState} timeout={300} classNames={'my-gift__main'}>
                  <div className={'my-gift__main'}>
                    <Filters filters={{ [CLOTH]: clothes, [WISH]: wishes }[customState]} customState={customState} />
                  </div>
                </CSSTransition>
              </SwitchTransition>
            </Scrollbar>
          </div>
          {buttons.map((button, index) => (
            <CustomButton key={index} {...button} />
          ))}
        </div>
        {(isPendingWish || isPendingEquip) && <AppLoader />}
      </section>
    </CustomModal>
  );
}
